import { usePermissions } from "@how/app-kit";
import type { ModuleKey, PermissionKey } from "@how/types";
import { LoadingState, PermissionDenied } from "@how/ui";
import type { ReactNode } from "react";

export interface RequireAnyPermissionProps {
  readonly anyOf: readonly PermissionKey[];
  readonly module?: ModuleKey;
  readonly children: ReactNode;
}

/**
 * Renders children when authorize_check allows any one of the permissions: a screen that opens to staff who read
 * every group and to leaders who read only their own (ADR 0040). The server still scopes every read and write.
 */
export function RequireAnyPermission({ anyOf, module, children }: RequireAnyPermissionProps) {
  const result = usePermissions(
    anyOf.map((permission) => ({ permission, ...(module === undefined ? {} : { module }) })),
  );
  if (result.isPending) return <LoadingState label="Checking your access" />;
  return anyOf.some((key) => result.allowed.has(key)) ? <>{children}</> : <PermissionDenied />;
}
